import { Injectable } from '@angular/core';
import { ProxyContext } from '@app/core/enums/proxy-context.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { HttpRequestService } from '@app/core/services/http-request.service';
import { Observable } from 'rxjs';
import { AddCartCommand } from '../command/add-cart-command';
import { IndividualGuideCommand } from '../command/individual-guide.command';

@Injectable({
  providedIn: 'root'
})
export class HomeServiceService {
  constructor(public requestService: HttpRequestService) {}

  /**
   * Method for call guide packs service
   *
   */
  getAllGuidePacks(): Observable<HttpServerResponse<any>> {
    return this.requestService.get<HttpServerResponse<any>>(ProxyContext.GetGuidePacks);
  }

  /**
   * Method for add producto to Cart
   */
  addProductToCart(addCartCommand: AddCartCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.AddToCart, addCartCommand);
  }

  /**
   * Method for get all indiidual guides
   *
   */
  getIndividialGuide(individualGuideCommand: IndividualGuideCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetGuideIndividual, individualGuideCommand);
  }
}
